import {
  ApiMethod,
  ControlItemValue,
  StaticControlItem,
} from '../../types/types';
import { RequestDataValue } from '../../context/RequestDataContext';
import { resolveTemplate } from '../../utils/json/resolveTemplate';
import { resolveApiPath } from './resolveApiPath';
import { fetcher } from './fetchers/fetcher';
import { detailedApiMethodFetcher } from './fetchers/detailedApiMethodFetcher';
import { apiRequest } from './apiRequest';
import { ResponseActionHandler } from '../../types/context';

// Shape of dynamic (apiMethod-based) control items used by list-based controls
// such as radioBtn, multiCheckbox and combobox.
export interface ApiMethodItems {
  apiMethod: ApiMethod;
  valueItem?: string;
  labelItem?: string;
}

// Fetches dynamic control options: resolves apiMethod placeholders, GETs data, maps to { value, label }.
// Shared by useControlApiMethodItems and useFormOptionsPrefetch.
export const fetchControlApiMethodOptions = async (
  controlItems: ApiMethodItems,
  requestData: RequestDataValue,
  getResponseActionHandler?: (name: string) => ResponseActionHandler | undefined
): Promise<StaticControlItem[]> => {
  const { apiMethod, valueItem = 'value', labelItem = 'label' } = controlItems;

  let data: any[];

  if (typeof apiMethod === 'string') {
    const { apiUrl } = await resolveTemplate(
      { apiUrl: apiMethod },
      requestData
    );
    const res = await fetcher(
      resolveApiPath(apiUrl as string),
      'GET',
      requestData.sessionId ?? null,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    );
    data = Array.isArray(res) ? res : [res];
  } else {
    const res = await apiRequest(
      apiMethod,
      requestData,
      detailedApiMethodFetcher,
      getResponseActionHandler
    );
    data = Array.isArray(res) ? res : [res];
  }

  return data.map((item: Record<string, any>) => ({
    value: (item[valueItem] ?? '') as ControlItemValue,
    label: String(item[labelItem] ?? item[valueItem] ?? ''),
  }));
};
